import { computed, type MaybeRef, unref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useApi } from "@shopexperts/shared";
import type { LeadAdminResponse } from "@shopexperts/legacy-api";

export function useAdminLeadDetail(leadId: MaybeRef<number | null | undefined>) {
  const api = useApi();
  const resolvedLeadId = computed(() => unref(leadId) ?? 0);

  const query = useQuery({
    queryKey: computed(() => ["admin", "leads-v2", "detail", resolvedLeadId.value]),
    queryFn: async (): Promise<LeadAdminResponse> => {
      return await api.admin.leadsV2.getLead({
        params: { id: resolvedLeadId.value },
      }) as LeadAdminResponse;
    },
    enabled: computed(() => resolvedLeadId.value > 0),
    staleTime: 10_000,
  });

  return {
    lead: computed(() => query.data.value ?? null),
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
